import { render, staticRenderFns } from "./HelpDeskNotification.vue?vue&type=template&id=6471b7e0&scoped=true"
import script from "./HelpDeskNotification.vue?vue&type=script&lang=js"
export * from "./HelpDeskNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6471b7e0",
  null
  
)

export default component.exports